import { render } from "./Shimingrenzheng.vue?vue&type=template&id=cdd8b92c&scoped=true"
import script from "./Shimingrenzheng.vue?vue&type=script&lang=js"
export * from "./Shimingrenzheng.vue?vue&type=script&lang=js"

import "./Shimingrenzheng.vue?vue&type=style&index=0&id=cdd8b92c&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd8b92c"]])

export default __exports__